export const LEAVE_TYPES = {
  "annual": "Yıllık İzin",
  "hourly": "Saatlik İzin",
  "medical": "Sağlık İzni",
  "marriage": "Evlilik İzni",
  "birth":"Doğum İzni",
  "unpaid": "Ücretsiz İzin",
  "special": "Özel İzin",
  "paternity": "Babalık İzni",
  "death": "Ölüm İzni"
};

export const LEAVE_STATUSES = {
  "pending": "Beklemede",
  "approved": "Onaylandı",
  "rejected": "Reddedildi"
}; 